const FR_CUSTOM = {


  // Temporary EN placeholders for parity. Replace with translated strings.
  "assumption.salesTaxPercent": "Sales Tax %",
  "chargingMap.otherSttations": "Other Types of Stations",
  "chargingMap.searchDealers": "Search Qualified Dealers",
  "chargingStations.mapLegend.high": "High Power Stations",
  "chargingStations.mapLegend.highSubtext": "DC fast charge or superchargers",
  "chargingStations.mapLegend.other": "Other Types of Stations",
  "chargingStations.mapLegend.private": "Private Stations",
  "chargingStations.mapLegend.public": "Public Stations",
  "chargingStations.mapLegend.publicSubtext": "Installed by business or government",
  "contact": "Contact",
  "currency": "$",
  "dealers": "Dealers",
  "dealers.allBrands": "All Brands",
  "dealers.allDealers": "All Dealers",
  "dealers.brands": "Brands",
  "dealers.contact": "CONTACT",
  "dealers.findDealers": "Find Dealers",
  "dealers.website": "WEBSITE",
  "electricians": "Electricians",
  "electricians.commercial": "Commercial",
  "electricians.fastEfficient": "{title} Our install timelines are secured and expedited to help get you up and running sooner.",
  "electricians.industrial": "Industrial",
  "electricians.map.header": "Benefits of our Preferred Partners",
  "electricians.map.personalizedExperience": "{title} Our EV Specialists can help guide you through the entire process.",
  "electricians.map.value": "{title} We offer competitive installation prices.",
  "electricians.residential": "Residential",
  "electricians.searchElectricians": "Search Qualified Electricians",
  "electricians.type": "Electrician Type",
  "electricians.worldClass": "{title} We partner with experienced electricians who are vetted to ensure a safe and professional installation",
  "electricity": "Electricity",
  "ev.carDetails.calc.charging": "Charging",
  "ev.carDetails.calc.DCFC": "DC Fast Charging (DCFC) Rate",
  "ev.carDetails.calc.description": "Description",
  "ev.cardetails.calc.EIA": "U.S. Energy Information Administration",
  "ev.cardetails.calc.electricEmissions": "Electric Emissions in Lbs",
  "ev.cardetails.calc.electricEmissionsLbsMwh": "Electric Emissions in Lbs/MWh",
  "ev.cardetails.calc.electricityEmissions": "Electricity Emissions in CO2 lbs/MWh",
  "ev.carDetails.calc.emissions": "Emissions",
  "ev.cardetails.calc.emissionsReductions": "Emissions Reductions",
  "ev.carDetails.calc.fuel": "Fuel",
  "ev.cardetails.calc.FuelConsumptionCa": "Canada Fuel Consumption Guide",
  "ev.cardetails.calc.gallonsSaved": "Gallons Saved",
  "ev.cardetails.calc.gallonsSavedFormula": "Gallons used by Equivalent Gas Vehicle - Gallons used by EV",
  "ev.cardetails.calc.gallonsUsed": "Gallons Used",
  "ev.cardetails.calc.gallonsUsedFormula": "Miles driven * (1 - Portion of Electric Driving) / MPG",
  "ev.cardetails.calc.gasolineEmissions": "Gasoline Emissions in Lbs per Gallon",
  "ev.cardetails.calc.gasolineEmissionsLbs": "Gasoline Emissions in Lbs",
  "ev.cardetails.calc.gasolineEmissionsYr": "Gasoline Emissions in lbs of CO2/yr",
  "ev.carDetails.calc.kwPerKm": "kWh per 100 km",
  "ev.carDetails.calc.kwPerMile": "kWh per 100 mi",
  "ev.cardetails.calc.lbsCo2PerYr": " lbs of CO2 per year",
  "ev.cardetails.calc.lPer100Km": "L/100 km",
  "ev.cardetails.calc.lpkm": " liters/kilometer",
  "ev.carDetails.calc.milesDriven": "Miles Driven Per Year",
  "ev.cardetails.calc.milesDrivenPerYr": "Miles driven per year",
  "ev.cardetails.calc.milesPerGallon": "Miles Per Gallon (MPG)",
  "ev.carDetails.calc.milesPerGallonBasic": "Miles Per Gallon",
  "ev.cardetails.calc.mpg": " miles/gal",
  "ev.carDetails.calc.source": "Source",
  "ev.cardetails.electricRange": "To account for battery degradation, the range quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.",
  "ev.carDetails.kilometerBatterySizeTooltip": "One kilowatt-hour (kWh) is enough energy to drive 1 to 4 miles, depending on the vehicle. A typical laptop battery can hold less than 0.1 kWh.",
  "ev.carDetails.kilometerUsedBatterySizeTooltip": "One kilowatt-hour (kWh) is enough energy to drive 1 to 4 kilometers, depending on the vehicle. To account for battery degradation for a used EV, the battery size quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.",
  "ev.carDetails.mobile": "For more details including charts {amp} calculations, please view this page on a desktop.",
  "ev.carDetails.usedBatterySizeTooltip": "One kilowatt-hour (kWh) is enough energy to drive 1 to 4 miles, depending on the vehicle. To account for battery degradation for a used EV, the battery size quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.",
  "ev.carDetails.view": "View vehicle details",
  "ev.chargingStations.body": " It's easier than ever to charge on the go. Enter your location to {lineBreak} see all charging stations near you.",
  "ev.compareOtherVehicles": "COMPARE OTHER VEHICLES",
  "ev.costOfPublicCharing": "Est. cost of public charging",
  "ev.dealers.body": "Discover electric vehicle dealers in your area, and click on each one to see location and contact information.",
  "ev.incentives.title.simple": "Available Incentives and Rebates",
  "ev.jumbotron.findADealer": "Find a Dealer",
  "ev.matchScore.adjustment": "Adjustment",
  "ev.matchScore.budget": "Budget",
  "ev.matchScore.charging": "Charging",
  "ev.matchScore.maxScore": "Max Score",
  "ev.matchScore.popover": "Your Match Score is based on your selected preferences.",
  "ev.matchScore.range": "Range",
  "ev.matchScore.seats": "Seats",
  "ev.matchScore.title": "Match Score",
  "ev.matchScore.totalScore": "Total Score",
  "ev.matchScore.yourScore": "Your Score",
  "ev.milesDrivenAnnually": "Miles Driven Per Year",
  "ev.planningRoute.body": "It’s easier than ever to charge on the go. Enter your destination to see all of the charging stations along the way.",
  "ev.public": "Public",
  "ev.publicPrivateCharging": "Mix public/private charging",
  "ev.showSources.blendedMaintenanceCostPerKilometer": "Blended maintenance cost per kilometer",
  "ev.showSources.blendedMaintenanceCostPerKilometerSource": "Portion of Electric Driving applied to Maintenance per kilometer for gasoline and for electricity",
  "ev.showSources.dollarPerKilometerDriven": "$/100 km driven",
  "ev.showSources.dollarPerKilometerDrivenPublicCharging": "(Estimated Cost of Public Charging * Mix Public/Private Charging + Electricity Rate * (1 - Mix Public/Private Charging)) * Vehicle kWh per 100 km",
  "ev.showSources.dollarPerKilometerDrivenSource": "Electricity Cost * Vehicle's kWh per 100 km",
  "ev.showSources.dollarPerMileDriven": "$/100 mi driven",
  "ev.showSources.dollarPerMileDrivenPublicCharging": "(Estimated Cost of Public Charging * Mix Public/Private Charging + Electricity Rate * (1 - Mix Public/Private Charging)) * Vehicle kWh per 100 mi",
  "ev.showSources.dollarPerMileDrivenSource": "Electricity Cost * Vehicle's kWh per 100 mi",
  "ev.showSources.electricityRate": "Electricity rate is based off of {website}",
  "ev.showSources.estimatedCostOfPublicCharging": "Estimated Cost of Public Charging",
  "ev.showSources.insuranceSource": "Average Insurance Cost In ",
  "ev.showSources.kilometerVehicleKWh": "Vehicle's kWh per 100 km",
  "ev.showSources.lifetimeKilometers": "Lifetime Kilometers",
  "ev.showSources.maintenancePerKilometer": "Maintenance per kilometer for gasoline",
  "ev.showSources.maintenancePerKilometerElectricity": "Maintenance per kilometer for electricity",
  "ev.showSources.maintenancePerKilometerElectricitySource": "Maintenance per kilometer for gasoline * EV Maintenance Reduction Factor",
  "ev.showSources.mixPublicPrivateCharging": "Mix Public/Private Charging",
  "ev.showSources.portionElectricSourceKilometer": "User input. For a hybrid vehicle, estimates the portion of kilometers driven using the electric battery instead of gasoline.",
  "ev.showSources.totalElectricityCostSource": "$/100 mi driven * Lifetime Miles * {portionEVDriving}/ 100",
  "ev.showSources.totalGasolineCostSource": "Gasoline Cost * Lifetime Miles *  {portionEVDriving}/ MPG",
  "ev.showSources.totalKilometerElectricityCostSource": "$/100 km driven * Lifetime Kilometers * {portionEVDriving}/ 100",
  "ev.showSources.totalKilometerGasolineCostSource": "Gasoline Cost * Lifetime Kilometers *  {portionEVDriving}/ lPerKm",
  "ev.showSources.totalKilometerMaintenanceCostSource": "Maintenance cost per kilometer * Lifetime Kilometers",
  "ev.showSources.vehicleKWh": "Vehicle's kWh per 100 mi",
  "ev.showSources.vehiclelPerKm": "Vehicle's LPerKm (liters per kilometer)",
  "ev.showSources.vehicleMPG": "Vehicle's MPG (miles per gallon)",
  "ev.used.electricRange": "Electric Range Average",
  "ev.used.yearRange": "Year Range",
  "ev.usedCarTitle": "Used {car}",
  "eventCard.hostedBy": "Hosted by",
  "eventCard.inPerson": "In Person Event",
  "eventCard.inPersonAndVirtual": "In Person + Virtual Event",
  "eventCard.learnMore": "Learn More",
  "eventCard.virtualEvent": "Virtual Event",
  "eventCatalog.noEvents": "No events matching your current search criteria can be found. Try changing your search criteria",
  "eventCatalog.noMatch": "We didn't find any matches.",
  "events": "Events",
  "events.allLocations": "All Locations",
  "events.autoshow": "Autoshow",
  "events.conference": "Conference",
  "events.distance": "Distance",
  "events.educationEvent": "Education Event",
  "events.inPerson": "In Person",
  "events.inPersonOrVirtual": "In Person or Virtual",
  "events.nationWide": "Nationwide",
  "events.rideAndDrive": "Ride and Drive",
  "events.subHeader": "See, touch and feel an electric vehicle for yourself at an upcoming event.",
  "events.training": "Training",
  "events.virtual": "Virtual",
  "events.webinar": "Webinar",
  "eventsDateRange": "Date Range",
  "eventsFilters": "Filters",
  "eventSort.dateLtH": "Date (Soonest first)",
  "evs.chargercard.chargingtime.na": "NA",
  "evs.chargerCatalog.noChargers": "No Chargers found",
  "evs.graph.compare": "Compare electric cars by EV range or price. Hover on the EV for more details.",
  "evs.graph.disclaimer": "Vehicles displayed may not reflect actual availability. {companyName} does not endorse or recommend any specific vehicle or car manufacturer.",
  "evs.graph.mobile": "To see the Range vs. Cost Graph, please view this page on a desktop.",
  "evs.graph.rangeVsCost": "Range vs. Cost",
  "evs.graph.tiles": "Vehicle Tiles",
  "evs.graph.title": "Electric Vehicles",
  "evs.highPower.legend": "High Power Stations",
  "evs.other.legend": "Other Types of Stations",
  "evs.public.legend": "Public Stations",
  "evs.welcomeSubMobile": "Tailor your search to discover electric vehicles that fit your needs.",
  "FAQ": "FAQ",
  "footer.chargingStations": "{chargingStations}",
  "footer.compareVehicles": "{compareVehicles}",
  "footer.copyright": "© 1998-2026 San Diego Gas & Electric Company. The trademarks used herein are the property of their respective owners. All rights reserved.",
  "footer.disclaimer": "{COMPANY_NAME}® Company is a subsidiary of Sempra®. SDG&E® and San Diego Gas & Electric are registered trademarks of San Diego Gas & Electric Company.",
  "footer.electricVehicles": "{electricVehicles}",
  "footer.homeChargers": "{homeChargers}",
  "footer.incentives": "{incentives}",
  "footer.ratepayerDisclaimer": "The messages contained on this site are funded by ratepayers unless otherwise noted.",
  "footer.zappyDisclaimer": "Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor SDGE provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.",
  "footer.zappyDisclaimer.one": "EV solutions © 2026 J.D. Power, provided with permission.",
  "ft": "ft",
  "galperyear": "gal/yr",
  "gasoline": "Gasoline",
  "graph.costDifferent": "Why is the cost different?",
  "graph.costVsRange.afterIncentives": "From at {price} after incentives",
  "graph.costVsRange.electricKilometerRange": "Electric Range: {kilometers} kilometers",
  "graph.costVsRange.electricRange": "Electric Range: {miles} miles",
  "graph.electricRange.assumptions": "Assumptions",
  "graph.electricRange.description": "Description",
  "graph.electricRange.electricity": "Electricity",
  "graph.electricRange.gasoline": "Gasoline",
  "graph.electricRange.subTitle": "The {car}'s electric range is {costDeltaText} by {number} miles",
  "graph.electricRange.total": "Total",
  "graph.fuelRange.chart.chargedHome": "charged at home",
  "graph.fuelRange.chart.description": "Description",
  "graph.fuelRange.chart.fuelBudget": "fuel budget",
  "graph.fuelRange.chart.howFar": "How far can you drive the {car} on a {budget} fuel budget?",
  "graph.fuelRange.chart.kilometers": "kilometers",
  "graph.fuelRange.chart.miles": "miles",
  "graph.fuelRange.chart.network": "on Plug-In EVerywhere network",
  "graph.fuelRange.chart.rangeOn": "Range on",
  "graph.fuelRange.chart.similarGas": "a similar Gas Vehicle",
  "graph.fuelRange.chart.unlimited": "Unlimited",
  "graph.hide": "Hide ",
  "graph.show": "Show ",
  "graph.showCostBreakdown": "Show Cost Breakdown",
  "graph.speedOfCharge.kilometersThirtyFastChargeThreeCars": "charges the most kilometers per 30 minutes of fast charging",
  "graph.speedOfCharge.kmThirtyFastCharge": "kilometers per 30 minutes of fast charging",
  "graph.speedOfCharge.mphLevelTwoCharger": "miles per hour with a level 2 charger",
  "graph.speedOfCharge.mphLevelTwoChargerThreeCars": "charges the most miles per hour with a level 2 charger",
  "graph.speedOfCharge.thirtyFastCharge": "miles per 30 minutes of fast charging",
  "graph.speedOfCharge.thirtyFastChargeThreeCars": "charges the most miles per 30 minutes of fast charging",
  "graph.title.miles": "Miles",
  "graph.title.totalRange": "Total Range",
  "header.chargingStations": "Charging Stations",
  "header.compareVehicles": "Compare Vehicles",
  "header.electricVehicles": "Electric Vehicles",
  "header.electricVehicles.v2": "Explore EVs",
  "header.home": "Home",
  "header.homeChargers": "Home Chargers",
  "header.incentives": "Incentives",
  "header.newVehicles": "Explore Electric Vehicle Options",
  "header.usedVehicles": "Explore Electric Vehicle Options",
  "homeChargers": "Home Chargers",
  "homeChargers.cable": "{length} ft. Cable",
  "homeChargers.cordLength": "Cord Length",
  "homeChargers.cordLengthHtL": "Cord Length: High to Low",
  "homeChargers.cordLengthLtH": "Cord Length: Low to High",
  "homeChargers.hardwired": "Hardwired",
  "homeChargers.meterCable": "{length} m Cable",
  "homeChargers.portable": "Portable",
  "homeChargers.price": "Price",
  "homeChargers.selectMake": "Select a Make",
  "homeChargers.selectModel": "Select a Model",
  "homeChargers.socket": "Socket",
  "homeChargers.socketTooltip": "Home EV chargers have varied plug patterns. These plug patterns correspond to the way their prongs fit into your wall outlet. If you’re not sure which socket is best for your home or garage, check with a certified electrician.",
  "homeChargers.subText": "Select the vehicle you are interested in to see the specific charging time to a full battery.",
  "homeChargers.title": "Home Chargers",
  "homeChargers.toFullCharge": "to full charge",
  "homeChargers.wallMounted": "Mounted",
  "homeChargers.wifi": "WiFi Connectivity",
  "homeChargersCard.beforeIncentives": "Before Incentives",
  "homeChargersCard.buy": "View Details",
  "homeChargersCard.socket": "{socket} Socket",
  "homeChargersCard.teslaWarning": "This charger only works with Teslas",
  "homepage.incentives.exporeIncentives": "EXPLORE INCENTIVES",
  "homepage.linkCard.findDealers": "Find {lineBreak} Dealers",
  "homepage.linkCard.homeChargers": "HOME {lineBreak} CHARGERS",
  "homepage.welcome": "Colton Recharged",
  "incentives.clunkertoolTip": "Certain incentives compensate you for retiring an existing vehicle, also known as a clunker. Specifically, the ",
  "incentives.clunkertoolTipContd": " are available in your region. Eligibility requirements vary by incentive; please check program details.",
  "incentives.electricityProvider": "Electricity Provider",
  "incentives.headOfHousehold": "Head of Household",
  "incentives.householdIncome": "Household Income",
  "incentives.householdIncomeTooltip": "Used to determine incentive eligibility. Include all members of your household (spouse, dependents, etc.). Few to no incentives mention households larger than 8 members, so select 8 if your household size is 8 or larger.",
  "incentives.householdSize": "Household Size",
  "incentives.householdSizeTooltip": "Include all members of your household (spouse, deoendants, etc). Used to determine incentived eligibility.",
  "incentives.income": "Income and tax status",
  "incentives.incomeTooltip": "Incentive eligibility and the amount you can receive often depends on your income. Lower  income customers are typically eligible for higher rebates.",
  "incentives.married": "Married",
  "incentives.retiringVehicleTooltip": "Retiring an old gas vehicle may be required for certain incentives.",
  "incentives.single": "Single",
  "incentives.taxFilingStatus": "Tax Filing Status",
  "incentives.taxFilingStatusTooltip": "Used to determine incentive eligibility.",
  "kgperyear": "kg/yr",
  "lbsperyear": "lbs/yr",
  "linkUnavailable": "Link to Network Unavailable",
  "literperyear": "L/yr",
  "loading": "Loading",
  "m": "m",
  "maps": "Maps",
  "newVehicles": "New Vehicles",
  "pages": "Pages",
  "results.updated": "Results have been updated as of ",
  "tabbed-maps-all-stations-tab": "Charging Stations",
  "tabbed-maps-dealer-catalog-tab": "Dealers",
  "tabbed-maps-electricians-tab": "Electricians",
  "tabbed-maps-route-tab": "Map a Route",
  "usedElectricVehicles": "Used Electric Vehicles",
  "vehicle.age.four": "4+ years old",
  "vehicle.age.one": "0-1 years old",
  "vehicle.age.two": "2-3 years old",
  "vehicle.gasoline.metricPrice": "Gasoline Price ($/L)",
  "vehicle.gasoline.price": "Gasoline Price ($/gal)",
  "vehicle.kilometersCapital": "Kilometers",
  "vehicle.kilometersShort": "km",
  "vehicle.milesCaptital": "Miles",
  "vehicle.milesPerThirtyFastCharge": "MILES PER 30 MIN OF FAST CHARGING",
  "vehicle.milesShort": "mi",
  "vehicles.none": "No vehicles found",
  "zipCode": "Zip Code",
}

export default FR_CUSTOM;